// @ts-nocheck
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetTaxExemptionCertificatesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetTaxExemptionCertificatesApiParameter & UpdateSearchFieldsType>;

export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Grefi/Pages/TaxExemptionCertificates/UpdateSearchFields",
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateSearchFields];

const updateSearchFields = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateSearchFields");
export default updateSearchFields;
